import styles from "./illustration.module.scss";
import type { IllustrationViewProps } from "./types-illustration";

export function IllustrationView({
  Art,
  viewBox,
  figma,
  size,
  width,
  title,
  titleId,
  role,
  ariaLabelledBy,
  ariaHidden,
  testId,
  className,
  style,
  rest,
}: IllustrationViewProps) {
  return (
    <svg
      className={className ? `${styles.root} ${className}` : styles.root}
      style={style}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      width={width}
      data-size={size}
      data-figma={figma}
      data-testid={testId}
      {...rest}
      role={role}
      aria-labelledby={ariaLabelledBy}
      aria-hidden={ariaHidden}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <Art />
    </svg>
  );
}
